/**
 * Auto-generated by Style Dictionary from DTCG tokens.
 * DO NOT EDIT — run `nx run tokens:code` to regenerate.
 *
 * @generated
 */

export const radiusBorderRadius = '2px' as const;

export const radiusRadius01 = '2px' as const;

export const radiusRadius02 = '4px' as const;

export const radiusRadius03 = '8px' as const;

export const radiusRadius04 = '1000000000px' as const;
